<div class="mb-10">
  <h1 class="text-3xl uppercase !leading-snug md:text-4xl">{{ 'title_reset_password' | translate }}</h1>
</div>
<form class="space-y-5 dark:text-white" [formGroup]="resetPwdForm" (ngSubmit)="onResetPassword()" autocomplete="off">
  <div>
    <label for="otp">{{ 'form_otp' | translate }}</label>
    <div class="relative text-white-dark">
      <input
        autocomplete="off"
        formControlName="otp"
        id="otp"
        type="otp"
        placeholder="{{ 'form_otp_placeholder' | translate }}"
        class="form-input ps-10 placeholder:text-white-dark"
        [class.is-invalid]="isSubmitted && resetPwdForm.controls['otp'].invalid"
      />
      <span class="absolute start-4 top-1/2 -translate-y-1/2"><i class="fa-solid fa-unlock-keyhole"></i> </span>
    </div>
    @if (resetPwdForm.get('otp')?.invalid && resetPwdForm.get('otp')?.touched) {
    <div class="text-red-500">
      {{ 'otp_validate_msg' | translate }}
    </div>
    }
  </div>
  <div>
    <label for="new_password">{{ 'form_label_new_password' | translate }}</label>
    <div class="relative text-white-dark">
      <input
        [type]="passwordVisible ? 'text' : 'password'"
        formControlName="new_password"
        placeholder="{{ 'form_label_password_placeholder' | translate }}"
        class="form-input ps-10 placeholder:text-white-dark"
        id="new_password"
      />
      <span class="absolute start-4 top-1/2 -translate-y-1/2">
        <i class="fa-solid fa-unlock-keyhole"></i>
      </span>
      <span
        class="absolute end-4 top-1/2 -translate-y-1/2 cursor-pointer"
        (click)="togglePasswordVisibility(); toggleIcon()"
        [ngClass]="{ 'text-dark': iconClicked, 'text-light': !iconClicked }"
      >
        <i class="fa-regular fa-eye"></i>
      </span>
    </div>
    @if (isSubmitted && resetPwdForm.controls['new_password'].hasError('required')) {
    <div class="text-danger">{{ 'new_pwd_req' | translate }}</div>
    } @if (resetPwdForm.controls['new_password'].touched && !allConditionsMet) {
    <div class="passwordCharMatch text-red-500">
      {{ passwordValidationMessage }}
    </div>
    }
  </div>

  <div>
    <label for="confirm_new_password">{{ 'form_label_confirm_password' | translate }}</label>
    <div class="relative text-white-dark">
      <input
        [type]="cnfPasswordVisible ? 'text' : 'password'"
        formControlName="confirm_new_password"
        placeholder="{{ 'form_label_password_placeholder' | translate }}"
        class="form-input ps-10 placeholder:text-white-dark"
        id="confirm_new_password"
      />
      <span class="absolute start-4 top-1/2 -translate-y-1/2"><i class="fa-solid fa-unlock-keyhole"></i> </span>
      <span
        class="absolute end-4 top-1/2 -translate-y-1/2 cursor-pointer"
        (click)="toggleCNFPasswordVisibility(); cnftoggleIcon()"
        [ngClass]="{ 'text-dark': cnficonClicked, 'text-light': !cnficonClicked }"
      >
        <i class="fa-regular fa-eye"></i>
      </span>
    </div>
    @if (isSubmitted && resetPwdForm.controls['confirm_new_password'].hasError('required')) {
    <div class="text-danger">
      {{ 'RESETPASSWORD.CONFIRM_PWD_REQ' | translate }}
    </div>
    }
  </div>

  <button type="submit" class="btn btn-gradient w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]">
    {{ 'reset_sbt_btn' | translate }}
  </button>

  <div class="text-center">
    <span class="text-white-dark hover:text-blue-500">&lt;</span
    ><a routerLink="/login" class="text-white-dark hover:text-blue-500">
      {{ 'login_link' | translate }}
    </a>
  </div>
</form>

@if (loading) {
<app-loader></app-loader>
}
